<p style="font-size:25px; color:red;font-weight: bold;">Image upload test page - <u>do not use!!</u></p>

<p-fileupload mode="basic" name="image" url="https://bmxv2.azurewebsites.net/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="1000000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileupload>

